import { render, staticRenderFns } from "./PhoneOTPLogin.vue?vue&type=template&id=949ca7de"
import script from "./PhoneOTPLogin.vue?vue&type=script&lang=js"
export * from "./PhoneOTPLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports